import { useParams, Link, Navigate } from "react-router-dom";
import {
  FaCheckCircle,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import { team } from "../data/content";

export default function TeamSingle() {
  const { id } = useParams();
  const member = team.find((m) => m.id === id);
  if (!member) return <Navigate to="/team" replace />;

  return (
    <>
      <PageHeader
        title={member.name}
        crumbs={[{ label: "Team", to: "/team" }, { label: member.name }]}
      />
      <section className="section">
        <div className="container two-col">
          <img src={member.image} alt={member.name} style={{ height: 480 }} />
          <div>
            <span className="subtitle">{member.role}</span>
            <h2 style={{ fontSize: 34, margin: "8px 0 16px" }}>{member.name}</h2>
            <p className="sec-text" style={{ marginBottom: 22 }}>{member.bio}</p>

            <ul className="check-list" style={{ marginBottom: 28 }}>
              {member.highlights.map((h, i) => (
                <li key={i}><FaCheckCircle /> {h}</li>
              ))}
            </ul>

            <div style={{ marginBottom: 28 }}>
              {member.skills.map((s, i) => (
                <div className="skill" key={i}>
                  <div className="skill-top">
                    <span>{s.label}</span>
                    <span className="text-yellow">{s.value}%</span>
                  </div>
                  <div className="skill-bar">
                    <div className="skill-fill" style={{ width: `${s.value}%` }} />
                  </div>
                </div>
              ))}
            </div>

            <div className="socials">
              <a href="#!"><FaFacebookF /></a>
              <a href="#!"><FaTwitter /></a>
              <a href="#!"><FaLinkedinIn /></a>
              <a href="#!"><FaInstagram /></a>
            </div>
            <Link to="/team" className="btn btn-outline mt-3">Back to Team</Link>
          </div>
        </div>
      </section>
    </>
  );
}
